import { Chip } from "@components/atoms/Chip"
import { LargeEventRow } from "@components/film/LargeEventRow"
import dayjs from "dayjs"
import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Year Round Tile",
  icon: "index-card",
}

export default defineBlock("templates/year-round-calendar-tile", (props) => {
  const tag = useInlineEditableValue<string>("tagLabel")
  return (
    <LargeEventRow
      startDate={dayjs(props.date)}
      endDate={props.endDate ? dayjs(props.endDate) : undefined}
      title={<EditableText store="title" defaultValue={props.link?.title || "Enter a title"} />}
      typeLabel={<EditableText store="typeLabel" defaultValue="Announcement" />}
      description={<EditableText store="description" placeholder="Enter an optional description" />}
      url={props.link?.url!}
      target={props.link?.target!}
      tags={
        <>
          {(!!env.admin || !!tag[0]) && (
            <Chip>
              <EditableText store={tag} placeholder="Optional tag" />
            </Chip>
          )}
        </>
      }
      programType={props.programType!}
    />
  )
})
